<template>
  <div class="medium-modal modal">

    <div class="modal-main">

      <p class="modal-heading">
        <span>ログインしてください。</span>
      </p>

      <p class="modal-body">
        <a href="javascript:void(0)" class="fb-btn social-btn">
          <div class="fb-signin-button" v-if="!this.getItem('access_token')" @click="onLoginBtnClicked">Facebookでログイン</div>
          <div class="fb-signin-button" v-if="this.getItem('access_token')" @click="onLogoutBtnClicked">Facebookからログアウト</div>
        </a>
      </p>

      <a href="javascript:void(0)" class="not-login" @click="closeElement(true)">今はしない</a>
    </div>

  </div>
</template>

<script>
import utils from '../../../utils/vue/Utils'
import storage from '../../../utils/vue/LocalStorage'
import VueCookies from 'vue-cookies'
import Vue from 'vue'

Vue.use(VueCookies)
export default {
  name: 'login-modal',
  methods: {
    onLoginBtnClicked () {
      let _this = this
      window.FB.getLoginStatus(function (response) {
        console.log(response)
        if (response.status === 'connected') {
          _this.handleFbLogin(response)
        } else {
          console.log('what is this....')
          window.FB.login(function (response) {
            if (response.status === 'connected') {
              _this.handleFbLogin(response)
            }
          })
        }
      })
    },
    onLogoutBtnClicked () {
      let _this = this
      window.FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          window.FB.logout(function (response) {
            _this.handleFbLogout()
          })
        } else {
          _this.handleFbLogout()
        }
      })
    },
    handleFbLogin (response) {
      this.postUserApi('auth/login', response).then((res) => {
        let {user, session} = res.data
        this.setItem('user_id', user.id)
        this.setItem('user_name', user.name)
        this.setItem('user_avatar', user.picture_large)
        this.setItem('access_token', session.access_token)
        this.setItem('fb_access_token', response.authResponse.accessToken)

        this.store.dispatch('user/setUserID', user.id)
        this.store.dispatch('user/setUserName', user.name)
        this.store.dispatch('user/setAccessToken', session.access_token)
        this.store.dispatch('user/setFbAccessToken', response.authResponse.accessToken)
        this.store.dispatch('user/setAvatar', user.picture_large)

        this.closeElement(true)
        this.showModal(this.constant.modal.util, null, true)
        this.getMarkerCoordinates()
        setTimeout(() => {
          this.closeElement(true)
        }, 3000)
        this.store.dispatch('modal/setMessage1', 'ログインしました')
      }).catch((error) => {
        console.error(error)
        this.showModal(this.constant.modal.util)
        this.store.dispatch('modal/setMessage1', 'ログインに失敗しました。')
      })
    },
    handleFbLogout () {
      this.postUserApi('auth/logout', null).then((res) => {
        this.logout()

        this.store.dispatch('user/setUserID', null)
        this.store.dispatch('user/setUserName', null)
        this.store.dispatch('user/setAccessToken', null)
        this.store.dispatch('user/setFbAccessToken', null)
        this.store.dispatch('user/setAvatar', null)
        this.showModal(this.constant.modal.util)
        this.store.dispatch('modal/setMessage1', 'ログインしました')
        this.getMarkerCoordinates()
      }).catch((error) => {
        console.error(error)
        this.showModal(this.constant.modal.util)
        this.store.dispatch('modal/setMessage1', 'ログインに失敗しました。')
      })
    }
  },
  mixins: [utils, storage]
}
</script>

<style lang="scss" scoped src="../scss/LoginModal.scss"></style>



// WEBPACK FOOTER //
// src/components/modal/vue/LoginModal.vue